import Axios from 'axios'
import * as R from 'ramda'

if (R.equals(process.env.NODE_ENV, 'production')) {
  Axios.defaults.baseURL = 'http://api.ceslyweb.com'
} else {
  Axios.defaults.baseURL = 'http://127.0.0.1:8000'
}

const credentials = sessionStorage.getItem('token')

if (credentials) {
  const data = JSON.parse(credentials)
  Axios.defaults.headers.common['Authorization'] = `${data.tokenType} ${data.accessToken}`
}
